type IconYoutubeProps = React.ComponentProps<"svg">;

export const IconYoutube: React.FC<IconYoutubeProps> = (props) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.7986 6.66811C20.7986 6.66811 20.601 5.27316 19.9925 4.66066C19.2219 3.85451 18.3604 3.85056 17.9653 3.80314C15.1359 3.59766 10.8878 3.59766 10.8878 3.59766H10.8799C10.8799 3.59766 6.63186 3.59766 3.80246 3.80314C3.40729 3.85056 2.54583 3.85451 1.77525 4.66066C1.1667 5.27316 0.973065 6.66811 0.973065 6.66811C0.973065 6.66811 0.767578 8.30805 0.767578 9.94404V11.4773C0.767578 13.1133 0.969113 14.7532 0.969113 14.7532C0.969113 14.7532 1.1667 16.1482 1.7713 16.7607C2.54188 17.5668 3.55351 17.5392 4.004 17.6261C5.62418 17.7802 10.8839 17.8276 10.8839 17.8276C10.8839 17.8276 15.1359 17.8197 17.9653 17.6182C18.3604 17.5708 19.2219 17.5668 19.9925 16.7607C20.601 16.1482 20.7986 14.7532 20.7986 14.7532C20.7986 14.7532 21.0001 13.1172 21.0001 11.4773V9.94404C21.0001 8.30805 20.7986 6.66811 20.7986 6.66811ZM8.79342 13.3385V7.65207L14.2586 10.5052L8.79342 13.3385Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconYoutube.displayName = "IconYoutube";
